var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnderline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4234 12.0287H0.396133C0.325428 12.0287 0.267578 12.0857 0.267578 12.1561V13.1756C0.267578 13.246 0.325428 13.3031 0.396133 13.3031H10.4234C10.4941 13.3031 10.552 13.246 10.552 13.1756V12.1561C10.552 12.0857 10.4941 12.0287 10.4234 12.0287ZM5.40977 10.7543C6.52498 10.7543 7.5727 10.2999 8.36331 9.47659C9.15393 8.65328 9.5878 7.55833 9.5878 6.39463V1.16301C9.5878 1.05234 9.50103 0.961792 9.39497 0.961792H8.43081C8.32475 0.961792 8.23797 1.05234 8.23797 1.16301V6.39463C8.23797 8.02113 6.9685 9.3458 5.40977 9.3458C3.85104 9.3458 2.58156 8.02113 2.58156 6.39463V1.16301C2.58156 1.05234 2.49479 0.961792 2.38873 0.961792H1.42457C1.31851 0.961792 1.23174 1.05234 1.23174 1.16301V6.39463C1.23174 7.55833 1.66722 8.6516 2.45622 9.47659C3.24523 10.3016 4.29456 10.7543 5.40977 10.7543Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.6e9e96ad19c11637899709a5184fd243.svg";
export { ForwardRef as ReactComponent };